export const flashcardConstants = {
  // Folders
  GET_ALL_FOLDERS_REQUEST: 'FLASHCARD_GET_ALL_FOLDERS_REQUEST',
  GET_ALL_FOLDERS_SUCCESS: 'FLASHCARD_GET_ALL_FOLDERS_SUCCESS',
  GET_ALL_FOLDERS_FAILURE: 'FLASHCARD_GET_ALL_FOLDERS_FAILURE',

  CREATE_FOLDER_REQUEST: 'FLASHCARD_CREATE_FOLDER_REQUEST',
  CREATE_FOLDER_SUCCESS: 'FLASHCARD_CREATE_FOLDER_SUCCESS',
  CREATE_FOLDER_FAILURE: 'FLASHCARD_CREATE_FOLDER_FAILURE',

  UPDATE_FOLDER_REQUEST: 'FLASHCARD_UPDATE_FOLDER_REQUEST',
  UPDATE_FOLDER_SUCCESS: 'FLASHCARD_UPDATE_FOLDER_SUCCESS',
  UPDATE_FOLDER_FAILURE: 'FLASHCARD_UPDATE_FOLDER_FAILURE',

  DELETE_FOLDER_REQUEST: 'FLASHCARD_DELETE_FOLDER_REQUEST',
  DELETE_FOLDER_SUCCESS: 'FLASHCARD_DELETE_FOLDER_SUCCESS',
  DELETE_FOLDER_FAILURE: 'FLASHCARD_DELETE_FOLDER_FAILURE',

  // Sets
  GET_ALL_SETS_REQUEST: 'FLASHCARD_GET_ALL_SETS_REQUEST',
  GET_ALL_SETS_SUCCESS: 'FLASHCARD_GET_ALL_SETS_SUCCESS',
  GET_ALL_SETS_FAILURE: 'FLASHCARD_GET_ALL_SETS_FAILURE',

  GET_SETS_BY_FOLDER_REQUEST: 'FLASHCARD_GET_SETS_BY_FOLDER_REQUEST',
  GET_SETS_BY_FOLDER_SUCCESS: 'FLASHCARD_GET_SETS_BY_FOLDER_SUCCESS',
  GET_SETS_BY_FOLDER_FAILURE: 'FLASHCARD_GET_SETS_BY_FOLDER_FAILURE',

  CREATE_SET_REQUEST: 'FLASHCARD_CREATE_SET_REQUEST',
  CREATE_SET_SUCCESS: 'FLASHCARD_CREATE_SET_SUCCESS',
  CREATE_SET_FAILURE: 'FLASHCARD_CREATE_SET_FAILURE',

  UPDATE_SET_REQUEST: 'FLASHCARD_UPDATE_SET_REQUEST',
  UPDATE_SET_SUCCESS: 'FLASHCARD_UPDATE_SET_SUCCESS',
  UPDATE_SET_FAILURE: 'FLASHCARD_UPDATE_SET_FAILURE',

  DELETE_SET_REQUEST: 'FLASHCARD_DELETE_SET_REQUEST',
  DELETE_SET_SUCCESS: 'FLASHCARD_DELETE_SET_SUCCESS',
  DELETE_SET_FAILURE: 'FLASHCARD_DELETE_SET_FAILURE',

  // Cards
  GET_ALL_CARDS_REQUEST: 'FLASHCARD_GET_ALL_CARDS_REQUEST',
  GET_ALL_CARDS_SUCCESS: 'FLASHCARD_GET_ALL_CARDS_SUCCESS',
  GET_ALL_CARDS_FAILURE: 'FLASHCARD_GET_ALL_CARDS_FAILURE',

  GET_CARDS_BY_SET_REQUEST: 'FLASHCARD_GET_CARDS_BY_SET_REQUEST',
  GET_CARDS_BY_SET_SUCCESS: 'FLASHCARD_GET_CARDS_BY_SET_SUCCESS',
  GET_CARDS_BY_SET_FAILURE: 'FLASHCARD_GET_CARDS_BY_SET_FAILURE',

  CREATE_CARD_REQUEST: 'FLASHCARD_CREATE_CARD_REQUEST',
  CREATE_CARD_SUCCESS: 'FLASHCARD_CREATE_CARD_SUCCESS',
  CREATE_CARD_FAILURE: 'FLASHCARD_CREATE_CARD_FAILURE',

  BULK_CREATE_CARDS_REQUEST: 'FLASHCARD_BULK_CREATE_CARDS_REQUEST',
  BULK_CREATE_CARDS_SUCCESS: 'FLASHCARD_BULK_CREATE_CARDS_SUCCESS',
  BULK_CREATE_CARDS_FAILURE: 'FLASHCARD_BULK_CREATE_CARDS_FAILURE',

  UPDATE_CARD_REQUEST: 'FLASHCARD_UPDATE_CARD_REQUEST',
  UPDATE_CARD_SUCCESS: 'FLASHCARD_UPDATE_CARD_SUCCESS',
  UPDATE_CARD_FAILURE: 'FLASHCARD_UPDATE_CARD_FAILURE',

  DELETE_CARD_REQUEST: 'FLASHCARD_DELETE_CARD_REQUEST',
  DELETE_CARD_SUCCESS: 'FLASHCARD_DELETE_CARD_SUCCESS',
  DELETE_CARD_FAILURE: 'FLASHCARD_DELETE_CARD_FAILURE',

  REORDER_CARDS_REQUEST: 'FLASHCARD_REORDER_CARDS_REQUEST',
  REORDER_CARDS_SUCCESS: 'FLASHCARD_REORDER_CARDS_SUCCESS',
  REORDER_CARDS_FAILURE: 'FLASHCARD_REORDER_CARDS_FAILURE',

  // Dictionary
  LOOKUP_WORD_REQUEST: 'FLASHCARD_LOOKUP_WORD_REQUEST',
  LOOKUP_WORD_SUCCESS: 'FLASHCARD_LOOKUP_WORD_SUCCESS',
  LOOKUP_WORD_FAILURE: 'FLASHCARD_LOOKUP_WORD_FAILURE',

  // Select folder
  SELECT_FOLDER: 'FLASHCARD_SELECT_FOLDER',
  CLEAR_SELECTION: 'FLASHCARD_CLEAR_SELECTION',
};
